module.exports = __webpack_public_path__ + "img/73.1.4fbd69ef.jpg";